"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putStocks = exports.PUT_STOCKS = void 0;
exports.PUT_STOCKS = '/v2/stocks';
const putStocks = (client) => async (sellerId, updateStockQuery) => {
    const res = await client.put(exports.PUT_STOCKS + `?sellerId=${sellerId}`, updateStockQuery);
    return res.data;
};
exports.putStocks = putStocks;
